import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./RequestsSettings')).RequestsSettings,
  'requestsSettings',
);
